/**
 * @file User authentication data and functions are stored here
 * @author Robert Ayetey
 */
/* eslint-disable */

import router from "../../router";

const state = {
  isValidated: false,
};

const getters = {
  getAuthenticationStatus: () => state.isValidated,
};

const actions = {
  // Perform login and logout of user here
  async authenticateUser({ commit }, payload) {
    // console.log(payload);

    const url = `${process.env.VUE_APP_BACKEND_API_ENDPOINT}/user`;
    // ### Perform authentication and login
    if (
      !getters.getAuthenticationStatus() &&
      payload.username &&
      payload.password
    ) {
      // if user is no logged in and makes request with username and password
      // then make a post request to the api
      // Make request to login API
      const response = await fetch(
        payload.param ? `${url}${payload.param}` : `${url}/login`,
        {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      // console.log(response);

      if (response.ok) {
        // Get the body of the response as json
        const jsonBody = await response.json();

        // Check body of response to see if login is successful and response is ok
        if (jsonBody.uid && jsonBody.loginStatus) {
          localStorage.setItem("uid", jsonBody.uid);
          localStorage.setItem("sdtkn", jsonBody.reqtk);

          // Change authentication status to logged in
          commit("SET_AUTHENTICATION_STATUS", true);
          return true;
        }
      }
    } else {
      // Change authentication status to logged in
      commit("SET_AUTHENTICATION_STATUS", false);
      return true;
    }

    return false;
  },

  // Request to create new user ie. signup
  async createUser({ commit }, payload) {
    // create base url to create user with
    const url = `${process.env.VUE_APP_BACKEND_API_ENDPOINT}/user/create`;

    const response = await fetch(`${url}`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    console.log(response);

    if (response) {
      // Get the body of the response as json
      const jsonBody = await response.json();

      // Check body of response to see if login is successful and response is ok
      return jsonBody;
    }

    return null;
  },
};

const mutations = {
  SET_AUTHENTICATION_STATUS(state, value) {
    if (value) {
      localStorage.setItem("akaditi-soko-delivery", "logged-in");
      router.push("/delivery");
    } else {
      localStorage.clear();
      router.history.go();
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
